export const SLICE_NAME = 'downloadMobileAppTile';
